/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ watts: NonNullable<unknown> }} Ui_More_Stats_Avg_PowerInputs */

const en_ui_more_stats_avg_power = /** @type {(inputs: Ui_More_Stats_Avg_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Avg ${i?.watts} W`)
};

const de_ui_more_stats_avg_power = /** @type {(inputs: Ui_More_Stats_Avg_PowerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ø ${i?.watts} W`)
};

/**
* | output |
* | --- |
* | "Avg {watts} W" |
*
* @param {Ui_More_Stats_Avg_PowerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_avg_power = /** @type {((inputs: Ui_More_Stats_Avg_PowerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_Avg_PowerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_avg_power(inputs)
	return de_ui_more_stats_avg_power(inputs)
});